import { http } from '@/core/api/';

const URL = 'api/disbursementrequest';

export const getRequestDetails = (requestId) =>
  http.get(`${URL}/details/${requestId}`);

export const getRequestDetailsByTapRequest = (tapRequestId) =>
  http.get(`${URL}/taprequestdetails/${tapRequestId}`);

export const checkTapRequestDisbursement = (tapRequestId) =>
  http.post(`${URL}/checktaprequest/${tapRequestId}`);

export const saveRequest = (parameters) => http.post(`${URL}/save`, parameters);

export const validateSsn = (ssn) => http.get(`${URL}/validatessn/${ssn}`);

export const getDisbursementRequestHistory = (params) =>
  http.get(`${URL}/history`, { params });

export const uploadOrUpdateFile = (payload) =>
  http.post(`${URL}/uploadorupdatedisbursementdocument`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const updateRequestStatus = (parameters) =>
  http.put(`${URL}/updaterequeststatus`, parameters);

export const savePartialRequest = (parameters) =>
  http.post(`${URL}/save/partial`, parameters, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const submitRequest = (payload) =>
  http.post(`${URL}/submit`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getSIFDERegistrationDocument = () =>
  http.get(`${URL}/sifderegistrydocument`);

export const getPaymentTabInfo = (billId) =>
  http.get(`${URL}/payment/${billId}`);

export const getServicesByPeriod = (studentSieId, month, year) =>
  http.get(`${URL}/getservicesbyperiod/${studentSieId}/${month}/${year}`);

export const getBlockedPeriods = (studentSieId, requestId, tapRequestId) =>
  http.get(
    `${URL}/getblockedperiods/${studentSieId}/${requestId}/${tapRequestId}`
  );

export const editSsn = (studentSie, ssn) =>
  http.put(`${URL}/editssn/${studentSie}/${ssn}`);

export const getInitFilters = (studentSieId) =>
  http.get(`${URL}/initfilter/${studentSieId}`);

export const checkTapRequestDisbursementByStudent = (
  studentSieId,
  academicYearId
) =>
  http.post(
    `${URL}/checktaprequestbystudent/${studentSieId}/${academicYearId}`
  );

export const saveSignatureHubMechanism = (requestId, isElectronicSignature) =>
  http.post(
    `${URL}/save-signaturehub-mechanism/${requestId}?isElectronicSignature=${isElectronicSignature}`
  );

export const getSignRefundCertificationUrl = (requestId) =>
  http.get(`${URL}/signrefundcertificationurl/${requestId}`);
